import api from "../../utils/api";
const common = {
  _loadScript(url) {
    return new Promise(resolve => {
      let script = document.createElement('script')
      script.setAttribute('type', 'text/javascript')
      script.setAttribute('src', url)
      document.getElementsByTagName('head')[0].appendChild(script)
      script.onload = () => {
        // console.log(`load ${url} success`)
        resolve()
      }
    })
  },
  // 严格按照顺序加载
  getPhotoSphereViewer(cssList, jsList) {
    return new Promise(async resolve => {
      cssList.map(href => {
        let link = document.createElement('link')
        link.setAttribute('rel', 'stylesheet')
        link.setAttribute('href', href)
        document.getElementsByTagName('head')[0].appendChild(link)
      })
      for (var url of jsList) {
        await this._loadScript(url)
      }
      // console.log('finish All')
      resolve()
    })
  },
  /**
   * 自定义获取数据说
   * @param {Object: VueInstance} obj vue实例
   * @param {Object} param1 方法参数
   *   @param className 类名
   *   @param funcName 方法名
   *   @param freeData 自定义参数
   */
  questData(obj, { className, funcName, freeData }) {
    return new Promise(resolve => {
      obj.$emit('questSelfMethod', {
        className: className,
        funcName: funcName,
        freeData: freeData,
        callback: (res) => {
          if (res.code == 200) {
            resolve(res)
          }
        }
      })
    })
  },
  getQueryString() {
    console.log('index js getQueryString')
    return new Promise((resolve, reject) => {
      let paramsObj = {};
      let search = decodeURI(window.location.search.substr(1));
      if (search) {
        let arr = search.split("&");
        arr.forEach(item => {
          let temArr = item.split("=");
          paramsObj[temArr[0]] = temArr[1];
        });
      } else if (localStorage.getItem('openid')) {
        paramsObj = {
          openid: localStorage.getItem('openid'),
          web_token: localStorage.getItem('web_token')
        }
      } else {
        resolve()
        return
      }
      resolve(paramsObj);
    });
  },
  async getLoginInfo(param) {
    console.log('index js  getLoginInfo ')
    // debugger
    if (!localStorage.getItem('user_info')) {
      const res = await api.loginByToken(param);
      if (!res) {
        return
      }
      // debugger
      if (res.status === 200) {
        if (res.data.code === 200) {
          // Bus._data.tabVisible = true
          localStorage.setItem('web_token', param.web_token)
          localStorage.setItem("openid", res.data.result.openid);
          localStorage.setItem(
            "user_info",
            JSON.stringify(res.data.result.user_info)
          );
          localStorage.setItem("user_id", res.data.result.user_info.id);
        }
      }
    }
  },
  async getTokenOpenId(res) {
    let param = {
      code: res.code
    }
    api.getTokenOpenId(param).then(res => {
      console.log('this is get token open id res ', res)
      let result = res.data.result
      localStorage.setItem('web_token', result.web_token)
      localStorage.setItem("openid", result.openid);
      window.location.href = '/user?web_token='+result.web_token+'&openid='+result.openid;						
    })
  }
}

export default common



// WEBPACK FOOTER //
// ./src/assets/js/index.js